module.exports = __webpack_public_path__ + "img/logo-inabio-ecuador.1782aa46.png";